import { ReactElement } from 'react';
import cc from 'classcat';
import { isMobile } from 'utils/is-mobile';
import { ENotRealSports } from 'interfaces/not-real-sports';
import { CompetitionSkeleton } from 'components/UI/Skeletons/CompetitionSkeleton';
import { SportsbookGameListHeaderSkeleton } from 'newcomponents/Shared/sportsbook/SportsbookGameListHeaderSkeleton';
import { Skeleton } from 'newcomponents/UI/Skeleton';
import { useSbRouteMatch } from 'newhooks/generic/useSbRouteMatch';
import './index.less';

type TGameListWrapperSkeletonProps = {
  withBack?: boolean;
  isLive: boolean;
  showHeader?: boolean;
  showMarketFilterSkeleton?: boolean;
  applyAdditionalMargin?: boolean;
};

export const GameListWrapperSkeleton = ({
  isLive,
  showHeader = true,
  showMarketFilterSkeleton = true,
  withBack,
  applyAdditionalMargin
}: TGameListWrapperSkeletonProps): ReactElement => {
  const { params } = useSbRouteMatch();

  return (
    <div
      className={`${
        isMobile()
          ? 'sportsbook-game-list__skeleton-mobile'
          : 'sportsbook-game-list__skeleton-desktop'
      } sportsbook-game-list__skeleton`}
    >
      {params.category === ENotRealSports.todayEvents && isMobile() ? (
        <div className="select_wraper">
          <Skeleton.Button active />
        </div>
      ) : (
        showHeader && (
          <SportsbookGameListHeaderSkeleton
            showSportNameWithFavorite={isLive && !isMobile()}
            showMarketFilterSkeleton={showMarketFilterSkeleton}
            isLive={isLive}
            withBack={withBack}
            applyAdditionalMargin={applyAdditionalMargin}
          />
        )
      )}
      <div
        className={cc([
          'sportsbook-game-list-wrapper__games',
          { 'sportsbook-game-list-wrapper__games-mobile': isMobile() }
        ])}
      >
        <CompetitionSkeleton
          category={params.category}
          sportAlias={params.sport}
          includeCollapse
          hideMargin
        />
      </div>
    </div>
  );
};
